import axios from "axios";
import { getCookie, setCookie, removeCookie } from "./Cookie";
import { refreshJWT } from "api/Login";

const jwtAxios = axios.create();

//요청 전
const beforeReq = (config) => {

    const userInfo = getCookie("login");
    if( !userInfo ) {
        console.log("User NOT FOUND");
        return Promise.reject(
            {response: {data: {error:"REQUIRE_LOGIN"}}}
        )
    }
    const {accessToken} = userInfo
    // Authorization 헤더 처리
    config.headers.Authorization = `Bearer ${accessToken}`
    return config
}

const beforeRes = async (res) => {


    const loginCookieValue = getCookie("login");
    const data = res.data
    if(data && data.error ==='ERROR_ACCESS_TOKEN'){
        const result = await refreshJWT( loginCookieValue.refreshToken );
        if (result.error) {
            removeCookie("login");
            location.reload(true);
            return;
        }
        loginCookieValue.accessToken = result.accessToken;
        loginCookieValue.refreshToken = result.refreshToken;

        setCookie("login", JSON.stringify(loginCookieValue), 1);
        const originalRequest = res.config;
        originalRequest.headers.Authorization = `Bearer ${result.accessToken}`
        return await axios(originalRequest);
    }
    return res
}

//fail request
const requestFail = (err) => {
    console.log("Request Error............")
    return Promise.reject(err);
}

//fail response
const responseFail = (err) => {
    console.log("Response Fail Error.............")
    return Promise.reject(err);
}

jwtAxios.interceptors.request.use( beforeReq, requestFail );
jwtAxios.interceptors.response.use( beforeRes, responseFail );
    
export default jwtAxios;